import React from "react";
import LegalLayout from "./LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Política de Privacidade" lastUpdate="Abril de 2026">
      <Section n="1" title="Introdução">
        <p>Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos os dados pessoais dos usuários do aplicativo de consultas psicológicas.</p>
        <p>Ao utilizar a plataforma, o usuário declara estar ciente e de acordo com as práticas descritas neste documento.</p>
      </Section>

      <Section n="2" title="Dados Coletados">
        <p>Podemos coletar os seguintes dados:</p>
        <h3 className="text-base font-semibold mt-3 mb-1">2.1 Dados Cadastrais</h3>
        <ul className="list-disc ml-6 space-y-1.5">
          <li>Nome completo</li>
          <li>E-mail</li>
          <li>Telefone</li>
        </ul>
        <h3 className="text-base font-semibold mt-3 mb-1">2.2 Dados Sensíveis (Saúde)</h3>
        <ul className="list-disc ml-6 space-y-1.5">
          <li>Informações fornecidas na anamnese</li>
          <li>Histórico psicológico</li>
          <li>Queixas e sintomas</li>
        </ul>
        <p>Esses dados são classificados como <strong>dados sensíveis</strong>, conforme a LGPD.</p>
      </Section>

      <Section n="3" title="Finalidade do Tratamento">
        <p>Os dados são utilizados para:</p>
        <ul className="list-disc ml-6 space-y-1.5">
          <li>Agendamento de consultas</li>
          <li>Comunicação entre paciente e psicólogo</li>
          <li>Registro de atendimentos</li>
          <li>Melhoria da experiência do usuário</li>
          <li>Cumprimento de obrigações legais e éticas</li>
        </ul>
      </Section>

      <Section n="4" title="Compartilhamento de Dados">
        <p>Os dados poderão ser compartilhados apenas quando necessário:</p>
        <ul className="list-disc ml-6 space-y-1.5">
          <li>Com psicólogos vinculados à plataforma</li>
          <li>Com serviços de tecnologia (ex: hospedagem, banco de dados)</li>
          <li>Para cumprimento de obrigações legais</li>
        </ul>
        <p>Não vendemos dados pessoais.</p>
      </Section>

      <Section n="5" title="Armazenamento e Segurança">
        <p>Adotamos medidas técnicas e organizacionais para proteger os dados contra:</p>
        <ul className="list-disc ml-6 space-y-1.5">
          <li>Acesso não autorizado</li>
          <li>Vazamentos</li>
          <li>Uso indevido</li>
        </ul>
        <p>Apesar disso, nenhum sistema é totalmente seguro, e o usuário também deve proteger suas credenciais.</p>
      </Section>

      <Section n="6" title="Direitos do Titular dos Dados">
        <p>Nos termos da LGPD, o usuário pode:</p>
        <ul className="list-disc ml-6 space-y-1.5">
          <li>Solicitar acesso aos dados</li>
          <li>Corrigir dados incompletos ou incorretos</li>
          <li>Solicitar exclusão dos dados</li>
          <li>Revogar consentimento</li>
        </ul>
        <p>Solicitações podem ser feitas através dos canais de atendimento.</p>
      </Section>

      <Section n="7" title="Retenção de Dados">
        <p>Os dados serão mantidos pelo tempo necessário para:</p>
        <ul className="list-disc ml-6 space-y-1.5">
          <li>Prestação dos serviços</li>
          <li>Cumprimento de obrigações legais</li>
        </ul>
      </Section>

      <Section n="8" title="Consentimento">
        <p>Ao utilizar a plataforma, o usuário consente com o tratamento de seus dados, inclusive dados sensíveis, para as finalidades descritas.</p>
      </Section>

      <Section n="9" title="Alterações">
        <p>Esta política pode ser atualizada a qualquer momento. Recomendamos revisão periódica.</p>
      </Section>

      <Section n="10" title="Contato">
        <p>Para dúvidas ou solicitações relacionadas à privacidade, o usuário pode entrar em contato com o suporte da plataforma.</p>
      </Section>
    </LegalLayout>
  );
}

function Section({ n, title, children }) {
  return (
    <section className="space-y-2">
      <h2 className="text-xl md:text-2xl font-semibold tracking-tight" style={{fontFamily:"'Outfit',sans-serif"}}>{n}. {title}</h2>
      <div className="space-y-2 text-[hsl(var(--text-secondary))]">{children}</div>
    </section>
  );
}
